var pug = require("!../../../../../../../node_modules/pug-runtime/index.js");

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;;var locals_for_with = (locals || {});(function (String, bindTo, field) {var id = field.id;
var property = field.property;
pug_html = pug_html + "\u003Cselect" + (" class=\"form-control input\""+" role=\"listbox\""+pug.attr("id", id, true, true)+pug.attr("aria-labelledby", id + "-Label", true, true)+pug.attr("aria-describedby", id + "-Validation", true, true)+pug.attr("data-bind", "value: " + bindTo(property, "select"), true, true)) + "\u003E";
// iterate field.values
;(function(){
  var $$obj = field.values;
  if ('number' == typeof $$obj.length) {
      for (var index = 0, $$l = $$obj.length; index < $$l; index++) {
        var option = $$obj[index];
pug_html = pug_html + "\u003Coption" + (" role=\"option\""+pug.attr("value", String(option), true, true)) + "\u003E" + (pug.escape(null == (pug_interp = field.valueMessages[index]) ? "" : pug_interp)) + "\u003C\u002Foption\u003E";
      }
  } else {
    var $$l = 0;
    for (var index in $$obj) {
      $$l++;
      var option = $$obj[index];
pug_html = pug_html + "\u003Coption" + (" role=\"option\""+pug.attr("value", String(option), true, true)) + "\u003E" + (pug.escape(null == (pug_interp = field.valueMessages[index]) ? "" : pug_interp)) + "\u003C\u002Foption\u003E";
    }
  }
}).call(this);

pug_html = pug_html + "\u003C\u002Fselect\u003E";}.call(this,"String" in locals_for_with?locals_for_with.String:typeof String!=="undefined"?String:undefined,"bindTo" in locals_for_with?locals_for_with.bindTo:typeof bindTo!=="undefined"?bindTo:undefined,"field" in locals_for_with?locals_for_with.field:typeof field!=="undefined"?field:undefined));;return pug_html;};
module.exports = template;